import axios from 'axios'
import { checkMockResponse } from './mock-interceptor'
import { isDev } from './dev-cookie'
import { getCache } from './cache'

// 创建两个不同的axios实例
const gdtvService = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '' : '',
  timeout: 15000
})

const mobileService = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '' : '',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// 通用request拦截器配置
const setupInterceptors = (service) => {
  service.interceptors.request.use(
    async config => {
      // 添加 Bearer Token 认证
      const token = getCache('token')
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }

      // 检查是否需要返回模拟数据
      if (isDev) {
        const mockResponse = await checkMockResponse(config)
        if (mockResponse) {
          return Promise.reject({
            config,
            response: {
              status: 200,
              data: mockResponse.data
            }
          })
        }
      }

      // 如果是移动端服务且是POST请求，确保数据格式正确
      if (service === mobileService && config.method === 'post') {
        if (!(config.data instanceof URLSearchParams)) {
          config.data = new URLSearchParams(config.data);
        }
        // 添加详细的请求日志
        console.log('Mobile service request:', {
          url: config.url,
          method: config.method,
          headers: config.headers,
          data: Object.fromEntries(config.data)
        });
      }
      return config
    },
    error => {
      console.log('Request error:', error)
      return Promise.reject(error)
    }
  )

  service.interceptors.response.use(
    response => {
      const res = response.data
      // 添加详细的响应日志
      if (service === mobileService) {
        console.log('Mobile service response:', {
          status: response.status,
          headers: response.headers,
          data: res
        });
      }
      return res
    },
    error => {
      // 如果是模拟数据的响应，直接返回模拟数据
      if (error.response?.status === 200 && error.config) {
        console.log('[开发环境] 返回模拟数据:', error.response.data);
        return error.response.data;
      }

      console.log('Response error:', error)
      if (error.response) {
        console.log('Error details:', {
          status: error.response.status,
          headers: error.response.headers,
          data: error.response.data,
          config: {
            url: error.config.url,
            method: error.config.method,
            headers: error.config.headers,
            data: error.config.data instanceof URLSearchParams 
              ? Object.fromEntries(error.config.data) 
              : error.config.data
          }
        })
      }
      return Promise.reject(error)
    }
  )
}

// 设置拦截器
setupInterceptors(gdtvService)
setupInterceptors(mobileService)

export { gdtvService as default, mobileService } 